<script setup>
import { ref, onMounted, nextTick, watch, computed } from "vue";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useRequestsStore } from "@/stores/storeRequests";
import { useQuestionnairesStore } from "@/stores/storeQuestionnaires";
import { useValidation } from "@/utils/useValidataion";
import Inputmask from "inputmask";

const storeField = useFieldsStore();
const storeRequests = useRequestsStore();


const value = ref(null);
const inputRef = ref(null);
const errorText = ref(null)
const errorMessage = ref('')

const heightErrorText = computed(() => {
    if (errorText.value) {
        return errorText.value.offsetHeight;
    }
})

const { validation, isValid, isTouched, textError } = useValidation(value);

const props = defineProps({
    type: {
		type: String,
        default: "text",
	},
	stateKey: {
		type: String,
	},
	placeholder: {
		type: String,
		default: "",
	},
	required: {
		type: Boolean,
	},
    maskType: {
        type: String,
        default: '',
    },
    maskPlaceholder: {
		type: String,
		default: "",
	},
    maxLength: {
        type: String,
        default: '',
    },
    minLength: {
        type: String,
        default: '',
    },
});

const getSimplifiedRegex = () => {
    
    if (props.maskType) {
        switch (props.maskType) {
            case 'email':
                return "^[a-zA-Z0-9._%+@-]*$";
            case 'cyrillic':
                return "^[А-Яа-яЁё\\s]*$";
            case 'digits':
                return "^[0-9]*$";
            case 'phone':
                return "^[0-9+\\-\\(\\)\\s]*$";
            default:
                return "";
        }
    }
};

const applyMask = () => {
	if (inputRef.value) {
		const im = new Inputmask({
			regex: getSimplifiedRegex(),
			placeholder: props.maskPlaceholder,
			clearIncomplete: true,
			showMaskOnHover: false,
            greedy: false, 
            autoUnmask: true,
            onKeyValidation: (key, result) => {
                if (!result && key) {
                    errorMessage.value = `Символ "${key}" не допускается.`;
                    setTimeout(() => {
                        errorMessage.value = '';
                    }, 3000);
                }
            },
			oncomplete: () => validation(props.stateKey),
			onincomplete: () => validation(props.stateKey),
		});
		im.mask(inputRef.value);
	}
};

onMounted(() => {
	nextTick(() => {
		applyMask();

        // Добавляем обработчик на изменение значения (в т.ч. автозаполнение)
        inputRef.value.addEventListener("change", () => {
            value.value = inputRef.value.value;
            storeField.updateFields(props.stateKey, "title", value.value);
            validation(props.stateKey);
        });
        
	});
	
});

const handleInput = (event) => {
	value.value = event.target.value;
	storeField.updateFields(props.stateKey, "title", value.value);
	validation(props.stateKey);
};
</script>

<template>
	<label :class="['input']">
		<div class="input__holder">			
			<input
				ref="inputRef"
				:type="type"
				:placeholder="placeholder"
				:required="required"
				:class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid')]"
				@input="handleInput"
				@blur="validation(stateKey)"
				:minlength="minLength"
                :maxlength="maxLength"
				v-model="value"
			/>
			<span class="input__title"><slot></slot></span>
		</div>

		<Transition mode="out-in">
            <span v-if="!!textError" ref="errorText" class="input__error" :style="{ bottom: `${0}px` }">{{ textError }}</span>
        </Transition>
        <Transition mode="out-in">
            <span v-if="!!errorMessage" ref="errorText" class="input__error" :style="{ bottom: `${0}px` }">{{ errorMessage }}</span>
        </Transition>
	</label>
</template>
<style lang='scss' scoped>



.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}

</style>